module.exports = __webpack_public_path__ + "media/images/ecute/ecutetokyo_zh-hans-e2f3f68194bac6f0a2dba8abb1ce3d54.jpg";